const BLOB_BASE = 'https://ldcgks2js4yteqrg.public.blob.vercel-storage.com/models';

export const MODEL_URLS = {
  Stonehush: `${BLOB_BASE}/Stonehush.glb`,
  Deeproot: `${BLOB_BASE}/Deeproot.glb`,
  Mirror_town: `${BLOB_BASE}/Mirror_town.glb`,
  The_unamed: `${BLOB_BASE}/The_unamed.glb`,
  Ashwick: `${BLOB_BASE}/Ashwick.glb`,
  Westwind: `${BLOB_BASE}/Westwind.glb`,
};
